import React, {useEffect, useRef, useState} from 'react';

import Box from "@mui/material/Box";
import {FormHelperText, InputLabel, Select, Stack, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {useForm} from "react-hook-form";


import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";

import {changeContractSearch} from "./contractSearchSlice";
import {getAllDataPointValues} from "../../DataPointValue/DataPointValueClient";




export default function ContractSearch() {

    const {register, handleSubmit} = useForm();

    const [contractValue, setContractValue] = useState([]);
    const dispatchData = useDispatch();

    const selectorContractType = useSelector((state) => state.contractSearchSlc.value.contractType);


    const [contractTypeDropdown, setContractTypeDropdown] = useState([]);
    const [selectedContractType, setSelectedContractType] = useState(null);

    const handleClearClick = () => {
        setContractValue("");
    };

    const handleClearContractClick = () => {
        setContractValue("");
    };



    const fetchDataPointValuesForDropdowns = () =>
        getAllDataPointValues()

            .then(data => {
                console.log(data);
                // Create a blank option and add it to the start of the array
                const blankOption = { id: '', name: '' };  // Define the blank row
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                // setContractTypeDropdown([
                //     blankOption,
                //     ...data.filter(item => item.dataPointId === 89)
                // ]);
                setContractTypeDropdown(
                    data.filter(item => item.dataPointId === 89)
                );

            })
    useEffect(() => {
        console.log("This is for the contract type dropdown...");
        fetchDataPointValuesForDropdowns();
    }, []);


                const handleContractTypeChange = (contractTypeEvent) => {
                    setSelectedContractType(contractTypeEvent.target.value);
                    console.log("This is for the selected Contract Type");
                    console.log(contractTypeEvent.target.value);
                };

    function onSubmit(data) {
        console.log("here's my contract search data before I submit it ")
        console.log({data});
        dispatchData(changeContractSearch({
            id: data.id,
            idFrom: data.idFrom,
            idTo: data.idTo,
            contractType: data.contractType,
            mcode: data.mcode,
            name: data.name,
            craatedOn: data.craatedOn,
            createdFrom: data.createdFrom,
            createdTo: data.createdTo,
            contractSearchGridRefresh: true
        }));
    };


    const searchForm  = () => (
        <form
            onSubmit={
            // console.log("Submitting search")
            handleSubmit((data)=>        onSubmit(data))
        }
        >
            <Box
                sx={{  height: 20, pl: 2}}/>
            <Box
                sx={{  height: 40, pl: 2}}
                role="presentation"
            >
                <Stack direction={"Horizontal"}  sx={{ pb: 1 }}>

                    <TextField variant="filled"
                               {...register('id', { required: false })}
                               id="id"   name="id"  label="ID" aria-describedby="id_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('idFrom', { required: false })}
                               id="idFrom"   name="idFrom"  label="ID From" aria-describedby="idFrom_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('idTo', { required: false })}
                               id="idTo"   name="idTo"  label="ID To" aria-describedby="idTo_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('createdOn', { required: false })}
                               id="createdOn"   name="createdOn"  label="Created On" aria-describedby="createdOn_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('createdFrom', { required: false })}
                               id="createdFrom"   name="createdFrom"  label="Created From" aria-describedby="createdFrom_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('createdTo', { required: false })}
                               id="createdTo"   name="createdTo"  label="Created To" aria-describedby="createdTo_entry"
                               sx={{ width: 150, pr: 5 }} />
                    {/*<Button onClick={() => handleBack()} >BACK</Button>*/}
                    {/*<Button onClick={() => handleHide()} >HIDE</Button>*/}
                {/*</Stack>*/}

                {/*<Stack direction={"Horizontal"}*/}
                {/*       sx={{ pb: 1 }}*/}
                {/*>*/}
                    <FormControl variant="filled"
                                 // sx={{m: 1, minWidth: 300}}
                                 sx={{ minWidth: 200, pr: 5 }}
                    >
                        <InputLabel htmlFor="contractType">Contract Type</InputLabel>
                        <Select
                            {...register('contractType', {required: false})}
                            labelId="demo-simple-select-filled-label2"
                            id="contractType"
                            label="Contract Type"
                            variant="filled"
                            onChange={handleContractTypeChange}
                            defaultValue={selectorContractType}
                        >
                            {contractTypeDropdown.map((contractTypeItem) =>
                                <MenuItem sx={{width: "50%"}}
                                          value={contractTypeItem.id}>{contractTypeItem.name}</MenuItem>
                            )}
                        </Select>
                        {/*<FormHelperText id="contract_type_helper">Where will this data come from?</FormHelperText>*/}
                    </FormControl>
                {/*</Stack>*/}

                {/*<Stack direction={"Horizontal"}*/}
                {/*    sx={{ pb: 1 }}*/}
                {/*>*/}
                    <TextField variant="filled"
                               {...register('mcode', { required: false })}
                               id="mcode"   name="mcode"  label="Code" aria-describedby="mcode_entry"
                               sx={{ width: 200, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('name', { required: false })}
                               id="name"   name="name"  label="Name" aria-describedby="name_entry"
                               sx={{ width: 300, pr: 5 }} />
                {/*</Stack>*/}

                {/*<Stack direction={"Horizontal"}  sx={{ pb: 1 }}>*/}

                {/*</Stack>*/}
                {/*<Stack direction={"Horizontal"}  sx={{ pb: 2 }}>*/}

                    <Button
                        type= "submit"
                    >RETRIEVE</Button>
                    <Button
                    >CLEAR</Button>
                </Stack>
            </Box>
        </form>
    );

    return (
        <div>
            {searchForm()}
        </div>

    )

}

